import type { GuestHomeResponse, UserHomeResponse } from "@core/home/types";
import { useIsGuest } from "@framework/account/hooks";

export function useModernHomePage(data: UserHomeResponse | GuestHomeResponse) {
  const isGuest = useIsGuest();
  const guestHome = data as GuestHomeResponse;
  const home = data as UserHomeResponse;

  return {
    announcements: data.announcements || [],
    assessments: data.grades?.assessments || [],
    banners: data.campaigns?.banners || [],
    categories: (data.grades?.categories || []).slice(0, 6),
    continueWatching: isGuest ? [] : home.continueWatching || [],
    grades: isGuest ? guestHome.grades?.grades || [] : [],
    hero: data.hero,
    isGuest,
    latestLessons: data.grades?.latestLessons || [],
    pinnedLessons: data.grades?.pinnedLessons || [],
    shorts: data.shorts || [],
    sliders: data.campaigns?.sliders || [],
    topGridClassName:
      isGuest && data.announcements?.length > 0
        ? "lg:grid-cols-[minmax(0,1.65fr)_minmax(18rem,0.75fr)]"
        : "grid-cols-1",
  };
}
